import { splitArrayToChunks } from "utility/helpers";

export const getRepresentativeRegions = (data) => {
  const newData = splitArrayToChunks(data, 3);
  let resultData = [];

  resultData =
    newData &&
    newData?.length &&
    newData?.length !== 0 &&
    newData.map((datum) => {
      return (
        datum?.length &&
        datum?.length !== 0 &&
        datum?.map((d) => {
          return {
            acronym: d.acronym,
            name: d.name,
            link: `/representatives/${d.id}`,
            label: `${d.acronym} - ${d.name}`,
            id: d?.id,
          };
        })
      );
    });

  return resultData;
};

const getModifiedArray = (list, id) => {
  let finalArr = [];

  if (list?.length === 0) return finalArr;

  finalArr = list?.map((l) => {
    const matches =
      l?.District?.name !== null && l?.District?.name.match(/(\d+)/);

    return {
      ...l,
      District: {
        ...l?.District,
        districtNumber:
          matches !== null && matches?.length !== 0 ? Number(matches[0]) : null,
      },
      img: l?.photo,
      link: `/representatives/${id}/cong/${l?.id}`,
    };
  });

  finalArr.sort((a, b) =>
    a?.District?.districtNumber > b?.District?.districtNumber ? 1 : -1
  );

  return finalArr;
};

export const getDistrictRepresentatives = (data, id) => {
  let resultData = [];

  const groupByCategory = data.reduce((group, datum) => {
    const { name } = datum.District.Province;
    // eslint-disable-next-line no-param-reassign
    group[name] = group[name] ?? [];
    group[name].push(datum);

    return group;
  }, {});

  const groupArray = Object.entries(groupByCategory);

  resultData =
    groupArray &&
    groupArray?.length !== 0 &&
    groupArray?.map((arr) => {
      // eslint-disable-next-line no-param-reassign
      return [arr[0], (arr[1] = getModifiedArray(arr[1], id))];
    });

  return resultData;
};

export const formatPartylistData = (data, id) => {
  return (
    data?.length !== 0 &&
    data?.map((datum) => {
      return {
        ...datum,
        img: datum.photo,
        link: `/representatives/${id}/cong/${datum?.id}`,
      };
    })
  );
};
